import { render } from "./TrashContent.vue?vue&type=template&id=96534a50"
import script from "./TrashContent.vue?vue&type=script&lang=js"
export * from "./TrashContent.vue?vue&type=script&lang=js"

import "./TrashContent.vue?vue&type=style&index=0&id=96534a50&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__